import { DomainBrandIdMap, BrandCodeToBrandIdMap } from './domain-map';
import { readLocallyStored } from '@ringcentral/rwc-utils/src/local-storage';

const LAB_DOMAIN = 'rclabenv.com';

const mockDomain = readLocallyStored('dynamicBrandingDomain') as string;
const currentDomain: string = document.location.origin.replace(/^https?:\/\//, '');

export const RING_CENTRAL_BRAND_ID = BrandCodeToBrandIdMap['rc_us'];

// https://docs.google.com/spreadsheets/d/1fizbsFfVt0jur4BjJnYOD1bk1t_oH0XTquRNTfyv4Ws/edit?gid=0#gid=0
export const RC_BRAND_IDS = ['1210', '2010', '3610', '3710', '5010'];

export const parseBrandInLabEnv = (domain: string): string => {
    const subDomainParts = domain
        .split('.')[0]
        .split('-')
        .reverse();
    let brandCode = subDomainParts[0];
    if (subDomainParts[0] === 'vss') {
        brandCode = subDomainParts[1];
    }

    return BrandCodeToBrandIdMap[brandCode];
};

export const getBrandIdFromUrlWithoutFallback = (): string => {
    const usingDomain = mockDomain || currentDomain;
    if (usingDomain.endsWith(LAB_DOMAIN)) {
        return parseBrandInLabEnv(usingDomain);
    }

    return DomainBrandIdMap[usingDomain];
};
